import clsx from "clsx";
import {
  extendTailwindMerge
} from "tailwind-merge";

const merge = extendTailwindMerge({
  separator: "_",
});

export const classnameMerge = (...args: clsx.ClassValue[]) => merge(clsx(...args));
